export const WorkedWith = [
  {
    ProjectName: "",
    ImageURL: "https://i.ytimg.com/vi/4GmiiekhOak/maxresdefault.jpg",
    CollaboratorName: ["Varun Mayya", "tanmay Bhat"],
    TopicsWeWorkedOn: [
      "Finetuned Image Models",
      "Interactive AI calling application",
      "Al enhanced Saas Products",
      "Consultancy Projects",
    ],
  },
  {
    ProjectName: "AiSensy",
    ImageURL: "https://i.ytimg.com/vi/wiy3CNnWLCw/maxresdefault.jpg",
    CollaboratorName: ["Gautam", "Mohit"],
    TopicsWeWorkedOn: [
      "Ai generated shorts",
      "AI video generation for user personalization at scale",
      "Consultancy Projects",
    ],
  },
  {
    ProjectName: "Unfinance",
    ImageURL:
      "data:image/png;base64,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",
    CollaboratorName: ["Kuwar", "Amit"],
    TopicsWeWorkedOn: [
      "Advanced AI chatbot for businesses ",
      "AI enhanced Saas Products",
      "Consultancy Projects",
    ],
  },
];

export const DeliveredProjects = [
  {
    ProjectName: "",
    ImageURL:
      "https://play-lh.googleusercontent.com/kEjOCr3uu-zfQHvqXgMollKbnTk23H0WHftb284_oOF7Ls7HO3XV-5w90ii98Yrbmeo=w526-h296-rw",
    CollaboratorName: ["KuKu Fm"],
    TopicsWeWorkedOn: [
      "Created advanced speech to text models ",
      "Al generated video content",
    ],
  },
  {
    ProjectName: "",
    ImageURL:
      "https://www.cityunionbank.com/filemanager/webimages/Value-Income-Plan.jpg",
    CollaboratorName: ["Tata AIA"],
    TopicsWeWorkedOn: [
      "Advanced chatbot system on WhatsApp. ",
      "With added features of sharing references of the knowledge",
    ],
  },
  {
    ProjectName: "",
    ImageURL:
      "https://www.goodreturns.in/img/2021/08/verse-innovation-rcbonar-1628748762.jpg",
    CollaboratorName: ["VerSe"],
    TopicsWeWorkedOn: [
      "Multiple agent chatbot system on WhatsApp ",
      "Created Action Models to work with API calls.",
    ],
  },
];
// export const AllProjectsData = [
//   {
//     Category: "AI Chatbots",
//     Description:
//       "A chatbot is a virtual conversation partner that simulates human interaction through text",
//     projectList: [
//       {
//         Image:
//           "https://blog-assets.freshworks.com/live-chat-software/wp-content/uploads/2020/08/21182122/Blog_Banner_v2-01.jpg",
//         Name: "AI Customer Support on WhatsApp",
//         Overview: "Short Intro here",
//         Introduction:
//           "Yardstick excels in crafting and integrating advanced Al models with current systems, focusing on solutions that significantly reduce costs and enhance revenue for businesses.",
//         Problem:
//           "Businesses often grapple with the challenges of maintaining large customer support teams, necessitating domain expertise to manage queries. The multilingual diversity in India further complicates communication, coupled with the absence of 24/7 customer support. Delayed responses, ranging from days to weeks, can result in the loss of valuable customers and revenue.",
//         Solution: "We propose the implementation of an Al-based customer support system on WhatsApp, offering an easily accessible, 24/7, multilingual, and prompt response service, specifically fine-tuned with the company's data.",
//         Features: [
//           {
//             Name: "Rapid Response",
//             Detail: "The Al bot delivers answers within 2-3 seconds on average.",
//           },
//           {
//             Name: "Multilingual Support",
//             Detail: "Capable of interacting in multiple languages to cater to diverse customer bases.",
//           },
//           {
//             Name: "Scalable Architechture",
//             Detail: "Designed to efficiently handle varying volumes of queries.",
//           },
//           {
//             Name: "Company Specific",
//             Detail: "Tailored responses based on the company's FAQ data.",
//           },
//           {
//             Name: "Customization",
//             Detail: "Flexibility to incorporate company-specific features as required.",
//           },
//         ],
//       },
//     ],
//   },
// ];

// export const AllProjectsData = [
//   {
//     Category: "AI Chatbots",
//     Description:
//       "A chatbot is a virtual conversation partner that simulates human interaction through text",
//     projectList: [
//       {
//         Image:
//           "https://cdn.analyticsvidhya.com/wp-content/uploads/2023/04/ai-generated-gba2dce9e3_1920_xMPNobD.jpg",
//         Name: "Customer Support Chatbot",
//         Overview: "24 x 7 customer support",
//         Details:
//           "Virtual assistant: Answers common questions, guides customers to solutions, automates simple tasks.24/7 availability: Resolves inquiries anytime, anywhere, reducing wait times.Personalized support: Learns from interactions, offering targeted solutions and improving satisfaction.",
//       },
//       {
//         Image:
//           "https://aerztestellen.aerzteblatt.de/sites/default/files/styles/daev_career_guide_article/public/chatbotc_phonlamaiphoto_adobe.jpg?itok=PN2IEox8",
//         Name: "Multi Agent System",
//         Overview:
//           "Use of external API and tools makes it a very powerful system",
//         Details: `Collaborative Chatbots: A team of virtual assistants, each specializing in different areas, work together to answer complex questions and solve customer problems seamlessly.
//         Contextual Conversations: Individual agents analyze interactions, learn user preferences, and share information, enabling personalized and relevant chatbot responses.
//         Dynamic Interactions: Agents can hand-off conversations, escalate to human agents, or work together in real-time for efficient multi-faceted conversations.
//         Scalability & Adaptability: Handles high volumes, adapts to diverse situations, and integrates with various systems, enhancing flexibility and reach.`,
//       },
//       {
//         Image:
//           "https://xcelacore.com/wp-content/uploads/2022/04/robotic-process-automation.jpg",
//         Name: "User Research and Insights",
//         Overview: "Data analytics and reports on bottlenecks and solutions",
//         Details:
//           "Delving into the world of users, user research unearths their needs, behaviors, and desires through interviews, surveys, and tests. This wealth of data is then transformed into valuable insights through careful analysis, revealing patterns and key understandings. Ultimately, these insights illuminate the path for informed design decisions, shaping products that resonate deeply with users and build brighter futures.",
//       },
//       {
//         Image:
//           "https://xcelacore.com/wp-content/uploads/2022/04/robotic-process-automation.jpg",
//         Name: "Automated Document collection and Validation ",
//         Overview: "Collect KYC and more documents on WhatsApp",
//         Details:
//           "Automated document collection and validation streamlines the often tedious process, turning it into a seamless experience. Gone are the days of chasing paper trails and manually checking data. Instead, documents are securely collected through portals or scanning apps, saving time and effort. Built-in validation tools then analyze content, ensuring accuracy and completeness, reducing errors and speeding up approval cycles. This powerful duo frees up resources, enhances efficiency, and fosters trust by safeguarding data integrity.",
//       },
//       {
//         Image:
//           "https://blog-assets.freshworks.com/live-chat-software/wp-content/uploads/2020/08/21182122/Blog_Banner_v2-01.jpg",
//         Name: "Schedule appointments on WhatsApp ",
//         Overview: "A chatbot helps you schedule and reschedule your meetings",
//         Details:
//           "Skip the hassle, schedule appointments directly on WhatsApp! Our friendly chatbot helps you book and reschedule meetings anytime, 24/7. Simply chat, choose a time, and get reminders - all within your familiar WhatsApp interface. Save time, stay organized, and enjoy flexible scheduling - the future of appointments is here!",
//       },
//       {
//         Image:
//           "https://cdn.openart.ai/stable_diffusion/84ec3ccf47313be2b2c81e0b4d699185678f21a5_2000x2000.webp",
//         Name: "Action Model Development",
//         Overview: "Models capable of performing actions",
//         Details:
//           "Schedule appointments on WhatsApp with cutting-edge AI models built to simplify your life. Leverage their powerful capabilities to book, reschedule, and manage appointments effortlessly – all within the familiar WhatsApp interface. Enjoy automated actions, reminders, and seamless integration for a stress-free scheduling experience.",
//       },
//     ],
//   },
//   {
//     Category: "Shipping Intelligent systems",
//     Description: "lghtbvvkxvm mbojfjd",
//     projectList: [
//       {
//         Image: "https://images6.alphacoders.com/349/349143.jpg",
//         Name: "shipping project",
//         Overview: "shipping support",
//         Details:
//           "Virtual assistant: Answers common questions, guides customers to solutions, automates simple tasks.24/7 availability: Resolves inquiries anytime, anywhere, reducing wait times.Personalized support: Learns from interactions, offering targeted solutions and improving satisfaction.",
//       },
//       {
//         Image: "https://images6.alphacoders.com/349/349143.jpg",
//         Name: "shipping project",
//         Overview: "shipping support",
//         Details:
//           "Virtual assistant: Answers common questions, guides customers to solutions, automates simple tasks.24/7 availability: Resolves inquiries anytime, anywhere, reducing wait times.Personalized support: Learns from interactions, offering targeted solutions and improving satisfaction.",
//       },
//       {
//         Image: "https://images6.alphacoders.com/349/349143.jpg",
//         Name: "shipping project",
//         Overview: "shipping support",
//         Details:
//           "Virtual assistant: Answers common questions, guides customers to solutions, automates simple tasks.24/7 availability: Resolves inquiries anytime, anywhere, reducing wait times.Personalized support: Learns from interactions, offering targeted solutions and improving satisfaction.",
//       },
//       {
//         Image: "https://images6.alphacoders.com/349/349143.jpg",
//         Name: "shipping project",
//         Overview: "shipping support",
//         Details:
//           "Virtual assistant: Answers common questions, guides customers to solutions, automates simple tasks.24/7 availability: Resolves inquiries anytime, anywhere, reducing wait times.Personalized support: Learns from interactions, offering targeted solutions and improving satisfaction.",
//       },
//       {
//         Image: "https://images6.alphacoders.com/349/349143.jpg",
//         Name: "shipping project",
//         Overview: "shipping support",
//         Details:
//           "Virtual assistant: Answers common questions, guides customers to solutions, automates simple tasks.24/7 availability: Resolves inquiries anytime, anywhere, reducing wait times.Personalized support: Learns from interactions, offering targeted solutions and improving satisfaction.",
//       },
//       {
//         Image: "https://images6.alphacoders.com/349/349143.jpg",
//         Name: "shipping project",
//         Overview: "shipping support",
//         Details:
//           "Virtual assistant: Answers common questions, guides customers to solutions, automates simple tasks.24/7 availability: Resolves inquiries anytime, anywhere, reducing wait times.Personalized support: Learns from interactions, offering targeted solutions and improving satisfaction.",
//       },
//     ],
//   },
//   {
//     Category: "Custom Frameworks over LLM",
//     Description: "Custom Frameworks over LLM",
//     projectList: [
//       {
//         Image:
//           "https://www.shutterstock.com/image-vector/llm-word-icons-vector-illustration-260nw-2298186725.jpg",
//         Name: "Custom Frameworks over LLM",
//         Overview: "Custom Frameworks over LLM",
//         Details:
//           "Virtual assistant: Answers common questions, guides customers to solutions, automates simple tasks.24/7 availability: Resolves inquiries anytime, anywhere, reducing wait times.Personalized support: Learns from interactions, offering targeted solutions and improving satisfaction.",
//       },
//       {
//         Image:
//           "https://www.shutterstock.com/image-vector/llm-word-icons-vector-illustration-260nw-2298186725.jpg",
//         Name: "Custom Frameworks over LLM",
//         Overview: "Custom Frameworks over LLM",
//         Details:
//           "Virtual assistant: Answers common questions, guides customers to solutions, automates simple tasks.24/7 availability: Resolves inquiries anytime, anywhere, reducing wait times.Personalized support: Learns from interactions, offering targeted solutions and improving satisfaction.",
//       },
//       {
//         Image:
//           "https://www.shutterstock.com/image-vector/llm-word-icons-vector-illustration-260nw-2298186725.jpg",
//         Name: "Custom Frameworks over LLM",
//         Overview: "Custom Frameworks over LLM",
//         Details:
//           "Virtual assistant: Answers common questions, guides customers to solutions, automates simple tasks.24/7 availability: Resolves inquiries anytime, anywhere, reducing wait times.Personalized support: Learns from interactions, offering targeted solutions and improving satisfaction.",
//       },
//       {
//         Image:
//           "https://www.shutterstock.com/image-vector/llm-word-icons-vector-illustration-260nw-2298186725.jpg",
//         Name: "Custom Frameworks over LLM",
//         Overview: "Custom Frameworks over LLM",
//         Details:
//           "Virtual assistant: Answers common questions, guides customers to solutions, automates simple tasks.24/7 availability: Resolves inquiries anytime, anywhere, reducing wait times.Personalized support: Learns from interactions, offering targeted solutions and improving satisfaction.",
//       },
//       {
//         Image:
//           "https://www.shutterstock.com/image-vector/llm-word-icons-vector-illustration-260nw-2298186725.jpg",
//         Name: "Custom Frameworks over LLM",
//         Overview: "Custom Frameworks over LLM",
//         Details:
//           "Virtual assistant: Answers common questions, guides customers to solutions, automates simple tasks.24/7 availability: Resolves inquiries anytime, anywhere, reducing wait times.Personalized support: Learns from interactions, offering targeted solutions and improving satisfaction.",
//       },
//     ],
//   },
//   {
//     Category: "Finetuning Models",
//     Description: "lghtbvvkxvm mbojfjd",
//     projectList: [
//       {
//         Image:
//           "https://azariangrowthagency.com/static/d49fe121f569e7210c4c5f5c982d169f/ab707/N1-Understanding-Fine-Tuning_.jpg",
//         Name: "fine tunning project",
//         Overview: "tunning support",
//         Details:
//           "Virtual assistant: Answers common questions, guides customers to solutions, automates simple tasks.24/7 availability: Resolves inquiries anytime, anywhere, reducing wait times.Personalized support: Learns from interactions, offering targeted solutions and improving satisfaction.",
//       },
//       {
//         Image:
//           "https://azariangrowthagency.com/static/d49fe121f569e7210c4c5f5c982d169f/ab707/N1-Understanding-Fine-Tuning_.jpg",
//         Name: "fine tunning project",
//         Overview: "tunning support",
//         Details:
//           "Virtual assistant: Answers common questions, guides customers to solutions, automates simple tasks.24/7 availability: Resolves inquiries anytime, anywhere, reducing wait times.Personalized support: Learns from interactions, offering targeted solutions and improving satisfaction.",
//       },
//       {
//         Image:
//           "https://azariangrowthagency.com/static/d49fe121f569e7210c4c5f5c982d169f/ab707/N1-Understanding-Fine-Tuning_.jpg",
//         Name: "fine tunning project",
//         Overview: "tunning support",
//         Details:
//           "Virtual assistant: Answers common questions, guides customers to solutions, automates simple tasks.24/7 availability: Resolves inquiries anytime, anywhere, reducing wait times.Personalized support: Learns from interactions, offering targeted solutions and improving satisfaction.",
//       },
//       {
//         Image:
//           "https://azariangrowthagency.com/static/d49fe121f569e7210c4c5f5c982d169f/ab707/N1-Understanding-Fine-Tuning_.jpg",
//         Name: "fine tunning project",
//         Overview: "tunning support",
//         Details:
//           "Virtual assistant: Answers common questions, guides customers to solutions, automates simple tasks.24/7 availability: Resolves inquiries anytime, anywhere, reducing wait times.Personalized support: Learns from interactions, offering targeted solutions and improving satisfaction.",
//       },
//     ],
//   },
// ];

export const AllProjectsData = [
  {
    Category: "E commerce Platforms",
    Description:
      "E-commerce platforms facilitate online transactions of goods and services.",
    projectList: [
      {
        Image:
          "https://cdn.analyticsvidhya.com/wp-content/uploads/2023/04/ai-generated-gba2dce9e3_1920_xMPNobD.jpg",
        Name: "SmartCart",
        Overview: "Revolutionizing online shopping experience",
        Introduction:
          "SmartCart is an innovative e-commerce platform aimed at providing users with a seamless and personalized shopping experience.SmartCart is an innovative e-commerce platform aimed at providing users with a seamless and personalized shopping experience.SmartCart is an innovative e-commerce platform aimed at providing users with a seamless and personalized shopping experience.SmartCart is an innovative e-commerce platform aimed at providing users with a seamless and personalized shopping experience.",
        Problem:
          `"Existing e-commerce platforms lack personalization and often overwhelm users with irrelevant product suggestions.Existing e-commerce platforms lack personalization and often overwhelm users with irrelevant product suggestions.Existing e-commerce platforms lack personalization and often overwhelm users with irrelevant product suggestions.Existing e-commerce platforms lack personalization and often overwhelm users with irrelevant product suggestions."`,
        Solution:
          "SmartCart utilizes advanced machine learning algorithms to analyze user behavior and preferences, offering personalized product recommendations and a streamlined checkout process.SmartCart utilizes advanced machine learning algorithms to analyze user behavior and preferences, offering personalized product recommendations and a streamlined checkout process.",
        Features: [
          {
            Name: "Personalized Recommendations",
            Detail:
              "Utilizes machine learning to suggest products based on user preferences and past purchases.",
          },
          {
            Name: "One-Click Checkout",
            Detail:
              "Allows users to complete purchases quickly with a single click, reducing cart abandonment rates.",
          },
          {
            Name: "Real-Time Inventory Management",
            Detail:
              "Ensures accurate product availability information for customers, minimizing order cancellations.",
          },
        ],
      },
      {
        Image:
          "https://cdn.analyticsvidhya.com/wp-content/uploads/2023/04/ai-generated-gba2dce9e3_1920_xMPNobD.jpg",
        Name: "MarketHub",
        Overview: "Empowering small businesses to thrive online",
        Introduction:
          "MarketHub is a comprehensive e-commerce solution designed specifically for small and medium-sized businesses, offering easy setup and management of online stores.MarketHub is a comprehensive e-commerce solution designed specifically for small and medium-sized businesses, offering easy setup and management of online stores.",
        Problem:
          "Small businesses struggle to establish a strong online presence due to limited resources and technical expertise.",
        Solution:
          "MarketHub provides user-friendly tools for website creation, product listing, and order management, enabling businesses to reach a wider audience and increase sales.",
        Features: [
          {
            Name: "Intuitive Website Builder",
            Detail:
              "Drag-and-drop interface for building customized e-commerce websites without coding knowledge.",
          },
          {
            Name: "Order Tracking",
            Detail:
              "Allows customers to track the status of their orders in real-time, enhancing transparency and trust.",
          },
          {
            Name: "Social Media Integration",
            Detail:
              "Enables seamless integration with social media platforms for marketing and customer engagement.",
          },
        ],
      },
      {
        Image:
          "https://cdn.analyticsvidhya.com/wp-content/uploads/2023/04/ai-generated-gba2dce9e3_1920_xMPNobD.jpg",
        Name: "GlobalMart",
        Overview: "Connecting buyers and sellers worldwide",
        Introduction:
          "GlobalMart is a multinational e-commerce platform that facilitates cross-border trade by connecting buyers and sellers from different countries.",
        Problem:
          "Traditional e-commerce platforms restrict sellers to local markets, limiting growth opportunities for businesses.",
        Solution:
          "GlobalMart provides a global marketplace where sellers can reach international customers and buyers can access a wide range of products from around the world.",
        Features: [
          {
            Name: "International Shipping",
            Detail:
              "Offers reliable shipping options for delivering products to customers worldwide.",
          },
          {
            Name: "Currency Conversion",
            Detail:
              "Automatically converts prices into the buyer's preferred currency for convenient shopping.",
          },
          {
            Name: "Multilingual Support",
            Detail:
              "Provides customer support and website interface in multiple languages to cater to global users.",
          },
        ],
      },
      {
        Image:
          "https://cdn.analyticsvidhya.com/wp-content/uploads/2023/04/ai-generated-gba2dce9e3_1920_xMPNobD.jpg",
        Name: "SmartCart",
        Overview: "Revolutionizing online shopping experience",
        Introduction:
          "SmartCart is an innovative e-commerce platform aimed at providing users with a seamless and personalized shopping experience.SmartCart is an innovative e-commerce platform aimed at providing users with a seamless and personalized shopping experience.SmartCart is an innovative e-commerce platform aimed at providing users with a seamless and personalized shopping experience.SmartCart is an innovative e-commerce platform aimed at providing users with a seamless and personalized shopping experience.",
        Problem:
          "Existing e-commerce platforms lack personalization and often overwhelm users with irrelevant product suggestions.Existing e-commerce platforms lack personalization and often overwhelm users with irrelevant product suggestions.Existing e-commerce platforms lack personalization and often overwhelm users with irrelevant product suggestions.Existing e-commerce platforms lack personalization and often overwhelm users with irrelevant product suggestions.",
        Solution:
          "SmartCart utilizes advanced machine learning algorithms to analyze user behavior and preferences, offering personalized product recommendations and a streamlined checkout process.SmartCart utilizes advanced machine learning algorithms to analyze user behavior and preferences, offering personalized product recommendations and a streamlined checkout process.",
        Features: [
          {
            Name: "Personalized Recommendations",
            Detail:
              "Utilizes machine learning to suggest products based on user preferences and past purchases.",
          },
          {
            Name: "One-Click Checkout",
            Detail:
              "Allows users to complete purchases quickly with a single click, reducing cart abandonment rates.",
          },
          {
            Name: "Real-Time Inventory Management",
            Detail:
              "Ensures accurate product availability information for customers, minimizing order cancellations.",
          },
        ],
      },
      {
        Image:
          "https://cdn.analyticsvidhya.com/wp-content/uploads/2023/04/ai-generated-gba2dce9e3_1920_xMPNobD.jpg",
        Name: "MarketHub",
        Overview: "Empowering small businesses to thrive online",
        Introduction:
          "MarketHub is a comprehensive e-commerce solution designed specifically for small and medium-sized businesses, offering easy setup and management of online stores.MarketHub is a comprehensive e-commerce solution designed specifically for small and medium-sized businesses, offering easy setup and management of online stores.",
        Problem:
          "Small businesses struggle to establish a strong online presence due to limited resources and technical expertise.",
        Solution:
          "MarketHub provides user-friendly tools for website creation, product listing, and order management, enabling businesses to reach a wider audience and increase sales.",
        Features: [
          {
            Name: "Intuitive Website Builder",
            Detail:
              "Drag-and-drop interface for building customized e-commerce websites without coding knowledge.",
          },
          {
            Name: "Order Tracking",
            Detail:
              "Allows customers to track the status of their orders in real-time, enhancing transparency and trust.",
          },
          {
            Name: "Social Media Integration",
            Detail:
              "Enables seamless integration with social media platforms for marketing and customer engagement.",
          },
        ],
      },
      {
        Image:
          "https://cdn.analyticsvidhya.com/wp-content/uploads/2023/04/ai-generated-gba2dce9e3_1920_xMPNobD.jpg",
        Name: "GlobalMart",
        Overview: "Connecting buyers and sellers worldwide",
        Introduction:
          "GlobalMart is a multinational e-commerce platform that facilitates cross-border trade by connecting buyers and sellers from different countries.",
        Problem:
          "Traditional e-commerce platforms restrict sellers to local markets, limiting growth opportunities for businesses.",
        Solution:
          "GlobalMart provides a global marketplace where sellers can reach international customers and buyers can access a wide range of products from around the world.",
        Features: [
          {
            Name: "International Shipping",
            Detail:
              "Offers reliable shipping options for delivering products to customers worldwide.",
          },
          {
            Name: "Currency Conversion",
            Detail:
              "Automatically converts prices into the buyer's preferred currency for convenient shopping.",
          },
          {
            Name: "Multilingual Support",
            Detail:
              "Provides customer support and website interface in multiple languages to cater to global users.",
          },
        ],
      },
    ],
  },
  {
    Category: "Healthcare Solutions",
    Description:
      "Healthcare solutions leverage technology to improve patient care and streamline medical processes.",
    projectList: [
      {
        Image:
          "https://images6.alphacoders.com/349/349143.jpg",
        Name: "MediCarePlus",
        Overview: "Empowering patients with telemedicine",
        Introduction:
          "MediCarePlus is a telemedicine platform that enables patients to consult with healthcare professionals remotely, ensuring access to medical care from anywhere.",
        Problem:
          "Patients face barriers to accessing healthcare, including long wait times for appointments and limited availability of specialists.",
        Solution:
          "MediCarePlus connects patients with qualified healthcare providers via video calls, allowing for timely consultations and reducing the need for in-person visits.",
        Features: [
          {
            Name: "Video Consultations",
            Detail:
              "Allows patients to have face-to-face consultations with healthcare professionals from the comfort of their homes.",
          },
          {
            Name: "Electronic Prescriptions",
            Detail:
              "Enables doctors to electronically send prescriptions to pharmacies, improving medication management.",
          },
          {
            Name: "Health Record Management",
            Detail:
              "Provides secure storage and access to patients' medical records, ensuring continuity of care.",
          },
        ],
      },
      {
        Image:
          "https://images6.alphacoders.com/349/349143.jpg",
        Name: "CareTrack",
        Overview: "Optimizing hospital operations",
        Introduction:
          "CareTrack is a hospital management system designed to streamline administrative tasks, enhance patient care, and improve overall operational efficiency.",
        Problem:
          "Hospital staff spend significant time on manual administrative tasks, leading to inefficiencies and errors in patient care.",
        Solution:
          "CareTrack automates routine administrative processes, such as appointment scheduling and inventory management, freeing up staff time for patient care.",
        Features: [
          {
            Name: "Appointment Scheduling",
            Detail:
              "Allows patients to book appointments online and helps staff manage schedules more efficiently.",
          },
          {
            Name: "Inventory Tracking",
            Detail:
              "Tracks hospital supplies and equipment to ensure availability and prevent stockouts.",
          },
          {
            Name: "Electronic Health Records",
            Detail:
              "Digitizes patient health records for easy access by healthcare providers, reducing paperwork and errors.",
          },
        ],
      },
      {
        Image:
          "https://images6.alphacoders.com/349/349143.jpg",
        Name: "MediAssist",
        Overview: "Enhancing patient engagement",
        Introduction:
          "MediAssist is a patient engagement platform that empowers individuals to take control of their health through personalized resources and interactive tools.",
        Problem:
          "Patients often lack access to educational resources and tools to manage their health outside of clinical settings.",
        Solution:
          "MediAssist provides patients with personalized health plans, educational materials, and interactive tools to promote self-care and proactive health management.",
        Features: [
          {
            Name: "Personalized Health Plans",
            Detail:
              "Creates customized health plans based on individual health goals and conditions.",
          },
          {
            Name: "Health Education Resources",
            Detail:
              "Offers a library of articles, videos, and infographics to educate patients about various health topics.",
          },
          {
            Name: "Symptom Checker",
            Detail:
              "Allows users to input symptoms and receive personalized recommendations for further action.",
          },
        ],
      },
      {
        Image:
          "https://images6.alphacoders.com/349/349143.jpg",
        Name: "MediCarePlus",
        Overview: "Empowering patients with telemedicine",
        Introduction:
          "MediCarePlus is a telemedicine platform that enables patients to consult with healthcare professionals remotely, ensuring access to medical care from anywhere.",
        Problem:
          "Patients face barriers to accessing healthcare, including long wait times for appointments and limited availability of specialists.",
        Solution:
          "MediCarePlus connects patients with qualified healthcare providers via video calls, allowing for timely consultations and reducing the need for in-person visits.",
        Features: [
          {
            Name: "Video Consultations",
            Detail:
              "Allows patients to have face-to-face consultations with healthcare professionals from the comfort of their homes.",
          },
          {
            Name: "Electronic Prescriptions",
            Detail:
              "Enables doctors to electronically send prescriptions to pharmacies, improving medication management.",
          },
          {
            Name: "Health Record Management",
            Detail:
              "Provides secure storage and access to patients' medical records, ensuring continuity of care.",
          },
        ],
      },
      {
        Image:
          "https://images6.alphacoders.com/349/349143.jpg",
        Name: "CareTrack",
        Overview: "Optimizing hospital operations",
        Introduction:
          "CareTrack is a hospital management system designed to streamline administrative tasks, enhance patient care, and improve overall operational efficiency.",
        Problem:
          "Hospital staff spend significant time on manual administrative tasks, leading to inefficiencies and errors in patient care.",
        Solution:
          "CareTrack automates routine administrative processes, such as appointment scheduling and inventory management, freeing up staff time for patient care.",
        Features: [
          {
            Name: "Appointment Scheduling",
            Detail:
              "Allows patients to book appointments online and helps staff manage schedules more efficiently.",
          },
          {
            Name: "Inventory Tracking",
            Detail:
              "Tracks hospital supplies and equipment to ensure availability and prevent stockouts.",
          },
          {
            Name: "Electronic Health Records",
            Detail:
              "Digitizes patient health records for easy access by healthcare providers, reducing paperwork and errors.",
          },
        ],
      },
      {
        Image:
          "https://images6.alphacoders.com/349/349143.jpg",
        Name: "MediAssist",
        Overview: "Enhancing patient engagement",
        Introduction:
          "MediAssist is a patient engagement platform that empowers individuals to take control of their health through personalized resources and interactive tools.",
        Problem:
          "Patients often lack access to educational resources and tools to manage their health outside of clinical settings.",
        Solution:
          "MediAssist provides patients with personalized health plans, educational materials, and interactive tools to promote self-care and proactive health management.",
        Features: [
          {
            Name: "Personalized Health Plans",
            Detail:
              "Creates customized health plans based on individual health goals and conditions.",
          },
          {
            Name: "Health Education Resources",
            Detail:
              "Offers a library of articles, videos, and infographics to educate patients about various health topics.",
          },
          {
            Name: "Symptom Checker",
            Detail:
              "Allows users to input symptoms and receive personalized recommendations for further action.",
          },
        ],
      },
    ],
  },
  {
    Category: "Educational Technology",
    Description:
      "Educational technology encompasses tools and platforms that enhance teaching and learning experiences.",
    projectList: [
      {
        Image:
          "https://aerztestellen.aerzteblatt.de/sites/default/files/styles/daev_career_guide_article/public/chatbotc_phonlamaiphoto_adobe.jpg?itok=PN2IEox8",
        Name: "LearnEase",
        Overview: "Revolutionizing online learning",
        Introduction:
          "LearnEase is an online learning platform that offers interactive courses and personalized learning experiences to students of all ages.LearnEase is an online learning platform that offers interactive courses and personalized learning experiences to students of all ages.LearnEase is an online learning platform that offers interactive courses and personalized learning experiences to students of all ages.LearnEase is an online learning platform that offers interactive courses and personalized learning experiences to students of all ages.LearnEase is an online learning platform that offers interactive courses and personalized learning experiences to students of all ages.LearnEase is an online learning platform that offers interactive courses and personalized learning experiences to students of all ages.LearnEase is an online learning platform that offers interactive courses and personalized learning experiences to students of all ages.LearnEase is an online learning platform that offers interactive courses and personalized learning experiences to students of all ages.",
        Problem:
          "Traditional education methods are often one-size-fits-all and fail to engage students effectively.Traditional education methods are often one-size-fits-all and fail to engage students effectively.Traditional education methods are often one-size-fits-all and fail to engage students effectively.Traditional education methods are often one-size-fits-all and fail to engage students effectively.Traditional education methods are often one-size-fits-all and fail to engage students effectively.Traditional education methods are often one-size-fits-all and fail to engage students effectively.Traditional education methods are often one-size-fits-all and fail to engage students effectively.Traditional education methods are often one-size-fits-all and fail to engage students effectively.Traditional education methods are often one-size-fits-all and fail to engage students effectively.",
        Solution:
          "LearnEase uses adaptive learning algorithms to tailor course content to each student's learning style and pace, promoting better retention and understanding.",
        Features: [
          {
            Name: "Adaptive Learning",
            Detail:
              "Adjusts course content and difficulty based on each student's performance and learning patterns.",
          },
          {
            Name: "Interactive Assessments",
            Detail:
              "Offers quizzes, exercises, and simulations to reinforce learning and assess comprehension.",
          },
          {
            Name: "Progress Tracking",
            Detail:
              "Allows students and teachers to monitor progress and identify areas for improvement.",
          },
        ],
      },
      {
        Image:
          "https://aerztestellen.aerzteblatt.de/sites/default/files/styles/daev_career_guide_article/public/chatbotc_phonlamaiphoto_adobe.jpg?itok=PN2IEox8",
        Name: "CodeCraft",
        Overview: "Teaching coding skills to kids",
        Introduction:
          "CodeCraft is an educational platform that teaches children coding skills through interactive games, projects, and challenges.CodeCraft is an educational platform that teaches children coding skills through interactive games, projects, and challenges.CodeCraft is an educational platform that teaches children coding skills through interactive games, projects, and challenges.",
        Problem:
          "Many children lack exposure to computer science and coding education, limiting their future career opportunities.Many children lack exposure to computer science and coding education, limiting their future career opportunities.Many children lack exposure to computer science and coding education, limiting their future career opportunities.Many children lack exposure to computer science and coding education, limiting their future career opportunities.",
        Solution:
          "CodeCraft introduces coding concepts in a fun and engaging way, fostering creativity and problem-solving skills in children from an early age.",
        Features: [
          {
            Name: "Game-based Learning",
            Detail:
              "Uses game mechanics to teach coding concepts and encourage exploration and experimentation.",
          },
          {
            Name: "Project-based Challenges",
            Detail:
              "Provides hands-on projects and challenges that allow students to apply coding skills to real-world scenarios.",
          },
          {
            Name: "Parental Dashboard",
            Detail:
              "Gives parents insights into their child's progress and learning journey, allowing them to support and encourage their development.",
          },
        ],
      },
      {
        Image:
          "https://aerztestellen.aerzteblatt.de/sites/default/files/styles/daev_career_guide_article/public/chatbotc_phonlamaiphoto_adobe.jpg?itok=PN2IEox8",
        Name: "MathMastery",
        Overview: "Improving math proficiency",
        Introduction:
          "MathMastery is an online platform that helps students improve their math skills through interactive lessons, practice exercises, and personalized feedback.MathMastery is an online platform that helps students improve their math skills through interactive lessons, practice exercises, and personalized feedback.MathMastery is an online platform that helps students improve their math skills through interactive lessons, practice exercises, and personalized feedback.MathMastery is an online platform that helps students improve their math skills through interactive lessons, practice exercises, and personalized feedback.",
        Problem:
          "Many students struggle with math concepts and lack access to personalized support outside of the classroom.Many students struggle with math concepts and lack access to personalized support outside of the classroom.Many students struggle with math concepts and lack access to personalized support outside of the classroom.Many students struggle with math concepts and lack access to personalized support outside of the classroom.",
        Solution:
          "MathMastery provides students with targeted practice and feedback to reinforce math concepts and build confidence in their abilities.",
        Features: [
          {
            Name: "Interactive Lessons",
            Detail:
              "Engaging multimedia lessons cover various math topics and concepts, catering to different learning styles.",
          },
          {
            Name: "Adaptive Practice",
            Detail:
              "Adapts difficulty levels based on student performance, ensuring appropriate challenge and support.",
          },
          {
            Name: "Progress Reports",
            Detail:
              "Generates detailed reports on student performance and areas for improvement, helping track progress over time.",
          },
        ],
      },
      {
        Image:
          "https://aerztestellen.aerzteblatt.de/sites/default/files/styles/daev_career_guide_article/public/chatbotc_phonlamaiphoto_adobe.jpg?itok=PN2IEox8",
        Name: "LearnEase",
        Overview: "Revolutionizing online learning",
        Introduction:
          "LearnEase is an online learning platform that offers interactive courses and personalized learning experiences to students of all ages.LearnEase is an online learning platform that offers interactive courses and personalized learning experiences to students of all ages.LearnEase is an online learning platform that offers interactive courses and personalized learning experiences to students of all ages.LearnEase is an online learning platform that offers interactive courses and personalized learning experiences to students of all ages.LearnEase is an online learning platform that offers interactive courses and personalized learning experiences to students of all ages.LearnEase is an online learning platform that offers interactive courses and personalized learning experiences to students of all ages.LearnEase is an online learning platform that offers interactive courses and personalized learning experiences to students of all ages.LearnEase is an online learning platform that offers interactive courses and personalized learning experiences to students of all ages.",
        Problem:
          "Traditional education methods are often one-size-fits-all and fail to engage students effectively.Traditional education methods are often one-size-fits-all and fail to engage students effectively.Traditional education methods are often one-size-fits-all and fail to engage students effectively.Traditional education methods are often one-size-fits-all and fail to engage students effectively.Traditional education methods are often one-size-fits-all and fail to engage students effectively.Traditional education methods are often one-size-fits-all and fail to engage students effectively.Traditional education methods are often one-size-fits-all and fail to engage students effectively.Traditional education methods are often one-size-fits-all and fail to engage students effectively.",
        Solution:
          "LearnEase uses adaptive learning algorithms to tailor course content to each student's learning style and pace, promoting better retention and understanding.",
        Features: [
          {
            Name: "Adaptive Learning",
            Detail:
              "Adjusts course content and difficulty based on each student's performance and learning patterns.",
          },
          {
            Name: "Interactive Assessments",
            Detail:
              "Offers quizzes, exercises, and simulations to reinforce learning and assess comprehension.",
          },
          {
            Name: "Progress Tracking",
            Detail:
              "Allows students and teachers to monitor progress and identify areas for improvement.",
          },
        ],
      },
      {
        Image:
          "https://aerztestellen.aerzteblatt.de/sites/default/files/styles/daev_career_guide_article/public/chatbotc_phonlamaiphoto_adobe.jpg?itok=PN2IEox8",
        Name: "CodeCraft",
        Overview: "Teaching coding skills to kids",
        Introduction:
          "CodeCraft is an educational platform that teaches children coding skills through interactive games, projects, and challenges.CodeCraft is an educational platform that teaches children coding skills through interactive games, projects, and challenges.CodeCraft is an educational platform that teaches children coding skills through interactive games, projects, and challenges.",
        Problem:
          "Many children lack exposure to computer science and coding education, limiting their future career opportunities.Many children lack exposure to computer science and coding education, limiting their future career opportunities.Many children lack exposure to computer science and coding education, limiting their future career opportunities.Many children lack exposure to computer science and coding education, limiting their future career opportunities.",
        Solution:
          "CodeCraft introduces coding concepts in a fun and engaging way, fostering creativity and problem-solving skills in children from an early age.",
        Features: [
          {
            Name: "Game-based Learning",
            Detail:
              "Uses game mechanics to teach coding concepts and encourage exploration and experimentation.",
          },
          {
            Name: "Project-based Challenges",
            Detail:
              "Provides hands-on projects and challenges that allow students to apply coding skills to real-world scenarios.",
          },
          {
            Name: "Parental Dashboard",
            Detail:
              "Gives parents insights into their child's progress and learning journey, allowing them to support and encourage their development.",
          },
        ],
      },
      {
        Image:
          "https://aerztestellen.aerzteblatt.de/sites/default/files/styles/daev_career_guide_article/public/chatbotc_phonlamaiphoto_adobe.jpg?itok=PN2IEox8",
        Name: "MathMastery",
        Overview: "Improving math proficiency",
        Introduction:
          "MathMastery is an online platform that helps students improve their math skills through interactive lessons, practice exercises, and personalized feedback.MathMastery is an online platform that helps students improve their math skills through interactive lessons, practice exercises, and personalized feedback.MathMastery is an online platform that helps students improve their math skills through interactive lessons, practice exercises, and personalized feedback.MathMastery is an online platform that helps students improve their math skills through interactive lessons, practice exercises, and personalized feedback.",
        Problem:
          "Many students struggle with math concepts and lack access to personalized support outside of the classroom.Many students struggle with math concepts and lack access to personalized support outside of the classroom.Many students struggle with math concepts and lack access to personalized support outside of the classroom.Many students struggle with math concepts and lack access to personalized support outside of the classroom.",
        Solution:
          "MathMastery provides students with targeted practice and feedback to reinforce math concepts and build confidence in their abilities.",
        Features: [
          {
            Name: "Interactive Lessons",
            Detail:
              "Engaging multimedia lessons cover various math topics and concepts, catering to different learning styles.",
          },
          {
            Name: "Adaptive Practice",
            Detail:
              "Adapts difficulty levels based on student performance, ensuring appropriate challenge and support.",
          },
          {
            Name: "Progress Reports",
            Detail:
              "Generates detailed reports on student performance and areas for improvement, helping track progress over time.",
          },
        ],
      },
    ],
  },
];
